import { render, staticRenderFns } from "./class_detail.vue?vue&type=template&id=ad91e2ca&scoped=true"
import script from "./class_detail.vue?vue&type=script&lang=js"
export * from "./class_detail.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/class-detail.scss?vue&type=style&index=0&id=ad91e2ca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad91e2ca",
  null
  
)

export default component.exports